import { Button } from 'foundations-components/transitional/components/Button';
import { DropdownCaret } from 'foundations-components/transitional/components/AbstractDropdown';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function DropdownButton(props) {
  return /*#__PURE__*/_jsxs(Button, Object.assign({}, props, {
    children: [props.children, /*#__PURE__*/_jsx(SmallDownCaret, {})]
  }));
}
export function SmallDownCaret() {
  return /*#__PURE__*/_jsx(DropdownCaret, {});
}